export default __webpack_public_path__ + "static/media/kvadeck.537b30ae.jpg";